jQuery(document).ready(function () {

    var answerTimerSpan = jQuery('#answer-timer');
    if (answerTimerSpan.length > 0) {
        require(['moment'], function (Moment) {

            var locale = parseInt(answerTimerSpan.data('locale'));
            Moment.locale(locale !== null ? locale : 'nl');

            var interval = null;
            var timeLeft = 1;

            function setTimeLeft() {
                var durationInSeconds = parseInt(answerTimerSpan.data('duration'));
                var started = Moment.utc(answerTimerSpan.data('started'));
                var startedAgo = Moment.duration(Moment() - started, 'ms');

                timeLeft = Moment.duration(durationInSeconds, 'seconds') - startedAgo;

                answerTimerSpan.text(Moment.duration(timeLeft).humanize());
            }

            function checkExpired() {
                if (timeLeft <= 0) {
                    jQuery('input[name=answering_time_expired]').val('1');
                    if (interval) clearInterval(interval);

                    var confirmationText = answerTimerSpan.data('confirmation');
                    var result = confirm(confirmationText);
                    if (!result) {
                        jQuery('input:checked').prop('checked', false);
                        jQuery('textarea').val('');
                    }
                    jQuery('#answer-form').each().submit();
                }
            }

            setTimeLeft();
            interval = setInterval(function () {
                setTimeLeft();
                checkExpired();
            }, 1000);
        });
    }

    /*
     * Scroll message to last message
     */
    if (jQuery('.list-clean.chat').length > 0) {

        var chat = jQuery('.list-clean.chat');

        var totalHeight = 0;

        jQuery(chat).children().each(function () {
            totalHeight = totalHeight + jQuery(this).outerHeight(true);
        });

        jQuery(window).scrollTop(totalHeight);
    }
});


// WEBPACK FOOTER //
// ./resources/assets/js/misc/client/client.js